import { Box, Stack } from '@mantine/core'

import {
  CarouselOrListingBlock,
  CarouselOrListingBlockProps,
} from 'components/molecules/carouselOrListingBlock'
import { useIsMobile } from 'hooks/useIsMobile'
import { Article, Category } from 'interfaces/types'

import { LazyItem } from './lazyItem'
import { CarouselOrListingBlockWrapper } from '../../carouselOrListingBlockWrapper'
import { Categories } from '../categories'
import { SingleAdvanceItem } from '../singleAdvanceItem'

type ArticleCardListProps = {
  articles: Article[]
  categories: Category[]
  dataTrackingCommon: any
  readmoreArticles?: string[]
  processClass?: {
    processRoot: string
    processBar: string
  }
  onSlideChange?: CarouselOrListingBlockProps['onSlideChange']
}
const AdvanceLayoutWithLoadMore = (props: ArticleCardListProps) => {
  const isMobile = useIsMobile()
  const { readmoreArticles = [], categories = [], onSlideChange } = props
  const numberItemInNormalSlide = isMobile ? 4 : 8

  return (
    <Stack spacing={40}>
      {readmoreArticles.length > 0 ? (
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <CarouselOrListingBlock
            showFullSlide={!isMobile}
            lengthToCarouselDesktop={2}
            percentOfEndSlideMobile={88}
            lazyLoad
            onSlideChange={onSlideChange}
            carouselSetting={{
              loop: false,
            }}
          >
            <CarouselOrListingBlockWrapper.Slider>
              {[
                ...new Array(
                  Math.round(
                    readmoreArticles.length / numberItemInNormalSlide,
                  ) + 1,
                ),
              ].map((_i, idx) => (
                <CarouselOrListingBlock.LazyLoadItem
                  key={String(idx)}
                  index={idx}
                >
                  {(isInView) =>
                    !isMobile && idx === 0 ? (
                      <Box>
                        <SingleAdvanceItem {...props} />
                      </Box>
                    ) : (
                      <LazyItem
                        loadIds={readmoreArticles.slice(
                          (idx - 1) * numberItemInNormalSlide,
                          (idx - 1) * numberItemInNormalSlide +
                            numberItemInNormalSlide,
                        )}
                        inView={isInView}
                        articles={idx === 0 ? props.articles : []}
                        dataTrackingCommon={props.dataTrackingCommon}
                      />
                    )
                  }
                </CarouselOrListingBlock.LazyLoadItem>
              ))}
            </CarouselOrListingBlockWrapper.Slider>
            <CarouselOrListingBlockWrapper.Paging
              sx={(theme) => ({
                position: 'absolute',
                bottom: `calc(100% + 40px)`,
                right: 0,
                [theme.fn.smallerThan('sm')]: {
                  display: 'none',
                },
              })}
            />
          </CarouselOrListingBlock>
        </Box>
      ) : (
        <SingleAdvanceItem {...props} />
      )}
      <Categories categories={categories} />
    </Stack>
  )
}

export { AdvanceLayoutWithLoadMore }
